import React from "react";
import MUIDataTable from "mui-datatables";
import { Tooltip } from "@mui/material";
import { Done, Error, Refresh } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import click from "../../assets/sound/click.mp3";
const Store = (props) => {
  const { data, onAdd, location } = props;

  const ModalFunc = (params) => {
    new Audio(click).play();
    onAdd(params);
  };
  const handleRefresh = () => {
    window.location.reload();
  };

  const columns = [
    {
      name: "id", // 0
      label: "id",
      options: {
        display: false,
      },
    },
    {
      name: "title", // 1
      label: "Title",
    },
    {
      name: "price", // 2
      label: "Price",
      options: {
        display: false,
      },
    },
    {
      name: "stock_all", // 2
      label: "stock",
      options: {
        display: false,
      },
    },
    {
      name: "?",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const row = tableMeta.rowData;
          const total = Number(row[3]);

          if (total >= 1)
            return (
              <Tooltip title="OK">
                <Done color="primary" />
              </Tooltip>
            );
          else
            return (
              <Tooltip title="Failing">
                <Error color="error" />
              </Tooltip>
            );
        },
      },
    },

    // Add more columns as needed
  ];
  const AddButton = () => (
    <>
      <Tooltip disableFocusListener title="Refresh DATA">
        <IconButton onClick={handleRefresh}>
          <Refresh />
        </IconButton>
      </Tooltip>
    </>
  );
  const options = {
    customToolbar: AddButton,
    selectableRowsHideCheckboxes: true,
    onRowClick: (rowData) => {
      ModalFunc(rowData);
    },
    sortOrder: {
      name: "title",
      direction: "asc",
    },
  };

  return (
    <>
      <MUIDataTable
        title={location}
        columns={columns}
        options={options}
        data={data}
      />
    </>
  );
};
export default Store;
